import { CompareToCustomDuration } from '@modules/quantify/store/types';
import dayjs from 'dayjs';

export const getDefaultCompareToCustomAbsoluteDuration = (
  timezone: string,
): CompareToCustomDuration => {
  return {
    type: 'timerange',
    duration: {
      type: 'absolute',
      startAfter: dayjs().tz().subtract(1, 'month'),
      endBefore: dayjs().tz(),
    },
  };
};
